import { render } from "./SuccessAlart.vue?vue&type=template&id=69e62d16&scoped=true"
import script from "./SuccessAlart.vue?vue&type=script&lang=js"
export * from "./SuccessAlart.vue?vue&type=script&lang=js"

import "./SuccessAlart.vue?vue&type=style&index=0&id=69e62d16&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69e62d16"

export default script